













import Campaign from "@/models/campaign";
import { LayoutModule } from "@/store/layout";

import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BehaviorReportSummary extends Vue {
  @Prop({ default: "" }) height!: string;

  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  details(): void {
    this.$router.push({
      name: "behaviorReport",
      params: { summary: "false" },
    });
  }
}
